"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnhancedEventEmitter = void 0;

var events_1 = require("events");

var Logger_1 = require("./Logger");

var logger = new Logger_1.Logger('EnhancedEventEmitter');

var EnhancedEventEmitter = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(EnhancedEventEmitter, _events_1$EventEmitte);

  var _super = _createSuper(EnhancedEventEmitter);

  function EnhancedEventEmitter() {
    var _this;

    _classCallCheck(this, EnhancedEventEmitter);

    _this = _super.call(this);

    _this.setMaxListeners(Infinity);

    return _this;
  }

  _createClass(EnhancedEventEmitter, [{
    key: "emit",
    value: function emit(eventName) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "emit", this)).call.apply(_get2, [this, eventName].concat(args));
    }
    /**
     * Special addition to the EventEmitter API.
     */

  }, {
    key: "safeEmit",
    value: function safeEmit(eventName) {
      var numListeners = _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "listenerCount", this).call(this, eventName);

      try {
        var _get3;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return (_get3 = _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "emit", this)).call.apply(_get3, [this, eventName].concat(args));
      } catch (error) {
        logger.error('safeEmit() | event listener threw an error [eventName:%s]:%o', eventName, error);
        return Boolean(numListeners);
      }
    }
  }, {
    key: "on",
    value: function on(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "on", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "off", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "addListener",
    value: function addListener(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "on", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "prependListener",
    value: function prependListener(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "prependListener", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "once",
    value: function once(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "once", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "prependOnceListener",
    value: function prependOnceListener(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "prependOnceListener", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "removeListener",
    value: function removeListener(eventName, listener) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "off", this).call(this, eventName, listener);

      return this;
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(eventName) {
      _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "removeAllListeners", this).call(this, eventName);

      return this;
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(eventName) {
      return _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "listenerCount", this).call(this, eventName);
    }
  }, {
    key: "listeners",
    value: function listeners(eventName) {
      return _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "listeners", this).call(this, eventName);
    }
  }, {
    key: "rawListeners",
    value: function rawListeners(eventName) {
      return _get(_getPrototypeOf(EnhancedEventEmitter.prototype), "rawListeners", this).call(this, eventName);
    }
  }]);

  return EnhancedEventEmitter;
}(events_1.EventEmitter);

exports.EnhancedEventEmitter = EnhancedEventEmitter;